module.exports = __webpack_public_path__ + "6e8452d5b9d6fe23488fdae21925c85b.otf";